import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { COMPANY } from "@/lib/constants";

const Impressum = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <main data-testid="impressum-page" className="pt-32 pb-24 bg-white min-h-screen">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <Link to="/" data-testid="impressum-back-link" className="inline-flex items-center gap-2 text-[#1FA3B5] font-medium hover:gap-3 transition-all">
          <ArrowLeft className="w-4 h-4" /> Zurück zur Startseite
        </Link>

        <h1 className="font-heading text-4xl lg:text-5xl font-bold text-slate-900 mt-8">Impressum</h1>
        <p className="mt-3 text-slate-500">Angaben gemäß § 5 TMG</p>

        <div className="mt-10 space-y-8 text-slate-700 leading-relaxed">
          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-3">Anbieter</h2>
            <p>
              {COMPANY.legalName}<br />
              {COMPANY.street}<br />
              {COMPANY.zip} {COMPANY.city}<br />
              Deutschland
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-3">Kontakt</h2>
            <p>
              Telefon: <a href={`tel:${COMPANY.phoneIntl.replace(/\s/g, "")}`} className="text-[#1FA3B5] hover:underline">{COMPANY.phoneDisplay}</a><br />
              E-Mail: <a href={`mailto:${COMPANY.email}`} className="text-[#1FA3B5] hover:underline">{COMPANY.email}</a>
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-3">Umsatzsteuer-ID</h2>
            <p>Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG: (folgt)</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-3">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
            <p>
              {COMPANY.legalName}<br />
              {COMPANY.street}, {COMPANY.zip} {COMPANY.city}
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-3">Haftung für Inhalte</h2>
            <p>
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
              Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen
              oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-3">Haftung für Links</h2>
            <p>
              Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für
              diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder
              Betreiber der Seiten verantwortlich.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-3">Urheberrecht</h2>
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht.
              Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen
              der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
          </section>
        </div>
      </div>
    </main>
  );
};

export default Impressum;
